import {Map} from 'immutable';
import {REDUCER_GET_CURRENT_PST, REDUCE_GET_QA_DICT_TYPE_GROUP} from '@store/types';

const initState = Map({
    currentPst: {},
    qaDict: null,
});

export default function common(state: any = initState, {type, data}: any) {
    switch (type) {
    case REDUCER_GET_CURRENT_PST:
        return state.setIn(['currentPst', data.mode], data.result);
    case REDUCE_GET_QA_DICT_TYPE_GROUP:
        return state.set('qaDict', data);
    default:
        return state;
    }
}